<template>
  <button :class="buttonClass" :type="type">
    <span v-show="!loading">
      <slot></slot>
    </span>
    <i class="fas fa-spinner fa-spin"></i>
  </button>
</template>

<script>
  export default {
    computed: {
      buttonClass () {
        let classObj = {}
        classObj[`ml-btn ml-btn--md ml-btn--${this.mode}`] = true
        return classObj
      }
    },
    name: 'MlButton',
    props: {
      loading: {
        default: false
      },
      type: {
        default: 'button'
      },
      mode: {
        default: 'primary'
      }
    }
  }
</script>

<style lang="scss">
  @import "../styles/theme";
</style>



// WEBPACK FOOTER //
// src/components/Button.vue